module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"ホームへ":"ホームへ"},"en":{"ホームへ":"Home"}}')
  delete Component.options._Ctor
}
